
export const R2_PUBLIC_BASE_URL = 'https://megalith-maps-r2-api.megalithmaps.workers.dev/image';


export const R2_WORKER_BASE_URL = 'https://megalith-maps-r2-api.megalithmaps.workers.dev'; // Updated
